'use client';
import { Quiz } from 'components/UI/Quiz';
import styles from './biological-age.module.scss';
import data from './data';

export const WidgetToolsCalculatorBiologicalAge = () => {
  return (
    <Quiz
      data={data}
      startButtonText="Test starten"
      nextButtonText="nächste Frage"
      previousButtonText="vorherige Frage"
      calculateButtonText="Ergebnis berechnen"
      recalculateButtonText="Neu berechnen"
      calculateResult={(state) => {
        if (!state.inputValue) return '';
        let bioAge = parseFloat(state.inputValue);
        state.answers.forEach((answer) => {
          bioAge += answer.points;
        });
        return Math.round(bioAge * 100) / 100;
      }}
      renderResult={(state, calculatedResult) => (
        <>
          <div className={styles.resultTitle}>Testauswertung:</div>

          <div className={styles.resultHeadline}>
            Dein kalendarisches Alter beträgt {state.inputValue} Jahre.
            <br />
            Dein biologisches Alter beträgt {calculatedResult} Jahre.
          </div>

          <p>
            Dein biologisches Alter ergibt sich aus deinen erblichen Veranlagungen, aber auch sehr stark aus deinem
            Verhalten. Lies hier noch einmal die Fragen dieses Tests und deine Antworten. Aus den Erläuterungen kannst
            du schließen, wie deine Antwort sich auf dein Ergebnis ausgewirkt hat.
          </p>
        </>
      )}
    />
  );
};
